import ReactDOM from 'react-dom'
import videojs from 'video.js'
import React from 'react'

import NextVidIcon from '../../../../assets/codicons/video-icons/next'

const vjsComponent = videojs.getComponent('Component')

class NextVid extends vjsComponent {
  constructor (player, options) {
    super(player, options)

    this.options = options

    player.ready(() => {
      this.mountElement()
    })

    /* Remove React root when component is destroyed */
    this.on('dispose', () => {
      ReactDOM.unmountComponentAtNode(this.el())
    })
  }

  mountElement () {
    ReactDOM.render(this.createNextButton(), this.el())
  }

  createNextButton () {
    return (
      <a href={this.options.url}>
        <NextVidIcon />
      </a>
    )
  }
}

vjsComponent.registerComponent('NextVid', NextVid)

export default NextVid
